import type { AppEnvType } from '@/consts/keys';
import { APP_ENV_TYPE } from '@/consts/keys';

export const getResetPwdPathUrl = () => {
  const envName = import.meta.env.VITE_APP_ENV as AppEnvType;

  switch (envName) {
    case APP_ENV_TYPE.SHOPL:
      return 'https://dashboard.shoplworks.com/dv2/reset-password';
    case APP_ENV_TYPE.CPS:
      return 'https://dashboard.cheilperfectstore.com/dv2/reset-password';
    case APP_ENV_TYPE.SSS:
      return 'https://dashboard.smartstoresolution.com/dv2/reset-password';
    case APP_ENV_TYPE.QA:
      return 'https://qa-dashboard.shoplworks.com/dv2/reset-password';
    case APP_ENV_TYPE.DEV:
      return 'https://dev.shopl.work/dv2/reset-password';
    case APP_ENV_TYPE.LOCAL:
      return 'http://localhost:3001/dv2/reset-password';
  }
};
